import { render, staticRenderFns } from "./multipleChoice.vue?vue&type=template&id=35e8ce6e&scoped=true"
import script from "./multipleChoice.vue?vue&type=script&lang=ts"
export * from "./multipleChoice.vue?vue&type=script&lang=ts"
import style0 from "./multipleChoice.vue?vue&type=style&index=0&id=35e8ce6e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/.pnpm/vue-loader@15.11.1_c2c4f8d10a02e12364bd9a7337709f82/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35e8ce6e",
  null
  
)

export default component.exports